import React from 'react';

import ChartDetail from '../../containers/ChartDetail';
import airGrade from '../../data/airGrade.json';

interface ChartDetailType {
  air: any;
}

const Humi = (props: ChartDetailType) => {
  const airHumi = props.air.humi;
  const title: string = '<b>습도</b>';

  return (
    <div>
      <ChartDetail
        data={airHumi?.data}
        created_at={airHumi?.created_at}
        title={title}
        airGrade={airGrade.data.humi}
      />
    </div>
  );
};

export default Humi;
